import { render, staticRenderFns } from "./signOutButton.vue?vue&type=template&id=06f36b28&scoped=true&"
import script from "./signOutButton.vue?vue&type=script&lang=js&"
export * from "./signOutButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f36b28",
  null
  
)

export default component.exports